var moduleMap = {
	"./App": () => {
		return __webpack_require__.e(619).then(() => (() => ((__webpack_require__(5619)))));
	},
	"./Dashboard": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(289), __webpack_require__.e(556), __webpack_require__.e(495), __webpack_require__.e(130)]).then(() => (() => ((__webpack_require__(4130)))));
	},
	"./Collections": () => {
		return Promise.all([__webpack_require__.e(300), __webpack_require__.e(561), __webpack_require__.e(878), __webpack_require__.e(76), __webpack_require__.e(483), __webpack_require__.e(574), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(519), __webpack_require__.e(999), __webpack_require__.e(289), __webpack_require__.e(809), __webpack_require__.e(556), __webpack_require__.e(936), __webpack_require__.e(72), __webpack_require__.e(195)]).then(() => (() => ((__webpack_require__(3195)))));
	},
	"./Payments": () => {
		return Promise.all([__webpack_require__.e(300), __webpack_require__.e(561), __webpack_require__.e(878), __webpack_require__.e(76), __webpack_require__.e(574), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(519), __webpack_require__.e(999), __webpack_require__.e(289), __webpack_require__.e(809), __webpack_require__.e(556), __webpack_require__.e(936), __webpack_require__.e(876)]).then(() => (() => ((__webpack_require__(9876)))));
	},
	"./EditInvoice": () => {
		return Promise.all([__webpack_require__.e(300), __webpack_require__.e(561), __webpack_require__.e(878), __webpack_require__.e(483), __webpack_require__.e(574), __webpack_require__.e(603), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(519), __webpack_require__.e(999), __webpack_require__.e(289), __webpack_require__.e(809), __webpack_require__.e(72), __webpack_require__.e(156)]).then(() => (() => ((__webpack_require__(6156)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});